import { render, staticRenderFns } from "./product-viewer.vue?vue&type=template&id=57f8fc91"
import script from "./product-viewer.vue?vue&type=script&lang=js"
export * from "./product-viewer.vue?vue&type=script&lang=js"
import style0 from "./product-viewer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports